import { MainLayout } from '@BUP/components';
import {
  NotFoundPage,
  HomePage,
  NoOrganizationPage,
  DataPage,
  ProfilePage,
  WebinarsPage
} from '@BUP/pages';
import {
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { ResourcesNavigation, ModeBupNavigation } from '@BUP/navigations';
import WebinarsNavigation from 'navigations/WebinarsNavigation';
import { RoleRoute, ModeBupRoute } from '@BUP/routes';
import { hasOrganization } from '@BUP/services/BraveUp';

const AppNavigation = ({ user, ...props }) => {

  if (!hasOrganization(user)) {
    return (
      <Switch>
        <Route component={NoOrganizationPage} path="/no-organization" exact />
        <Route>
          <Redirect to="/no-organization" />
        </Route>
      </Switch>
    )
  }
  return (
    <MainLayout>
      <Switch>
        <Route component={HomePage} path="/" exact />
        <Route component={ResourcesNavigation} path="/resources" />
        <Route component={WebinarsNavigation} path="/webinars" />
        <Route component={ModeBupNavigation} path="/modebup" />
        <Route component={DataPage} path="/data" />
        <Route component={ProfilePage} path="/profile" />
        <Route>
          <Redirect to="/" />
        </Route>
      </Switch>
    </MainLayout>
  )
}

export default AppNavigation;